import { inject, type InjectionKey } from 'vue'

import type {
  OperacoesCatalogoLocalDeTrabalho,
} from '../catalogo-local-de-trabalho.tipos'

export const CHAVE_OPERACOES_CATALOGO_LOCAL_DE_TRABALHO:
InjectionKey<OperacoesCatalogoLocalDeTrabalho> =
  Symbol('operacoes-catalogo-local-de-trabalho')

export const usarOperacoesCatalogoLocalDeTrabalho = (
): OperacoesCatalogoLocalDeTrabalho => {
  const operacoes = inject(CHAVE_OPERACOES_CATALOGO_LOCAL_DE_TRABALHO)
  if (!operacoes) {
    throw new Error('Catalogo de local de trabalho nao foi instalado')
  }
  return operacoes
}
